export const buildLinkContextItems = (row = {}) => {
  const items = []

  if (row.relatedPromoTitle) {
    items.push({
      label: row.relatedPromoTitle,
      title: row.relatedPromoTitle,
    })
  }

  if (row.relatedProductName) {
    items.push({
      label: row.relatedProductName,
      title: row.relatedProductName,
    })
  }

  const brandNames = (row.relatedBrandNames || []).filter(Boolean)

  if (brandNames.length > 0) {
    const visibleNames = brandNames.slice(0, 2)
    const hiddenCount = brandNames.length - visibleNames.length
    let label = visibleNames.join(', ')

    if (hiddenCount > 0) {
      label = `${label} +${hiddenCount}`
    }

    items.push({
      label,
      title: brandNames.join(', '),
    })
  }

  const categoryLabel = row.relatedCategoryPathLabel || row.relatedGlobalCategoryName || ''

  if (categoryLabel) {
    items.push({
      label: categoryLabel,
      title: categoryLabel,
    })
  }

  return items
}

export default buildLinkContextItems
